import { Typography } from '@one-thd/sui-atomic-components';
import React, { useState } from 'react';
import { PoJobNameModal } from '../purchase-history/table-view/PoJobNameModal';
import { pushOrderDetailOverlayEvent } from '../../utils/order-details/analytics';
export var PoJobName = function (_a) {
    var _b;
    var order = _a.order;
    var initPoJobName = (order === null || order === void 0 ? void 0 : order.POJobName) === ((_b = order === null || order === void 0 ? void 0 : order.orderNumbers) === null || _b === void 0 ? void 0 : _b[0])
        ? 'Add PO/Job Name'
        : order === null || order === void 0 ? void 0 : order.POJobName;
    var _c = useState(false), openModal = _c[0], setOpenModal = _c[1];
    var _d = useState(initPoJobName), visiblePoJobName = _d[0], setVisiblePoJobName = _d[1];
    return (React.createElement("div", { className: "sui-flex sui-flex-row" },
        React.createElement("div", { className: "sui-flex" },
            React.createElement("div", { className: "sui-min-w-[116px] sui-max-w-[116px]" },
                React.createElement(Typography, { variant: "body-base", weight: "bold" }, "PO/Job Name:")),
            React.createElement("div", { className: "sui-ml-2 sui-mr-3" },
                React.createElement(Typography, { variant: "body-base" }, visiblePoJobName))),
        React.createElement("button", { type: "button", className: "sui-underline", onClick: function () {
                pushOrderDetailOverlayEvent('po name');
                setOpenModal(true);
            } },
            React.createElement(Typography, { variant: "body-base" }, "Edit")),
        openModal && (React.createElement(PoJobNameModal, { page: "OrderDetails", openModal: openModal, order: order, setOpenModal: setOpenModal, setVisiblePoJobName: setVisiblePoJobName, visiblePoJobName: visiblePoJobName }))));
};
